<template>
    <PageContent>
        <PageTitle>Customers <Help /></PageTitle>
        <NotReady v-if="!ready" />
        <div v-else>
          <DataTable :options="tableOptions" :columns="[
              { data: 'No_' },
              { data: 'Name' },
              { data: 'City' },
              { data: 'Phone No_' },
              { data: null, orderable: false, searchable: false }
            ]" ref="dataTable" class="display table table-sm table-striped table-bordered is-responsive" style="width:100%">

              <thead>
                <tr>
                  <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Customer No</th>
                  <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Name</th>
                  <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">City</th>
                  <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Phone No</th>
                  <th style="background-color: var(--bs-gray-700); color: var(--bs-white);"></th>
                </tr>
                <tr>
                  <td><input type="text" class="form-control form-control-sm" placeholder="Search by Customer No..." @input="searchColumn(0, $event)" /></td>
                  <td><input type="text" class="form-control form-control-sm" placeholder="Search by Name..." @input="searchColumn(1, $event)" /></td>
                  <td><input type="text" class="form-control form-control-sm" placeholder="Search by City..." @input="searchColumn(2, $event)" /></td>
                  <td></td>
                  <td></td>
                </tr>
              </thead>
              <template #column-0="{ rowData, rowIndex }">
                {{ rowData['No_']+'&nbsp;' }}
              </template>
              <template #column-4="{ rowData, rowIndex }">
                <span style="white-space: nowrap;">
                  <a href="#" @click.prevent="impersonate(rowData)" class="me-1 mt-1 mb-1 btn btn-sm btn-primary" data-title="View As" data-intro="Impersonate a customer.">View As</a>
                  <a :href="`/customers/${rowData['No_']}/users/`" class="me-1 mt-1 mb-1 btn btn-sm btn-primary" data-title="Customer Users" data-intro="View all users for this customer.">Users</a>
                  <a :href="`/customers/${rowData['No_']}/edit`" class="me-1 mt-1 mb-1 btn btn-sm btn-secondary" data-title="Edit Customer" data-intro="Edit the customer">Edit</a>
                </span>
              </template>
            </DataTable>
          
        </div>
        
    </PageContent>
  </template>
  
  <script>
  // @ is an alias to /src
  import ColumnChooser from '@/components/Items/ColumnChooser.vue';
  import PriceCodes from '@/components/Items/PriceCodes.vue';
  import ItemListCodeArea from '@/components/Items/ItemListCodeArea.vue';
  import Modal from '@/components/Modal.vue';
  import PageContent from '@/components/PageContent.vue';
  import NotReady from '@/components/NotReady.vue';
  import PageTitle from '@/components/PageTitle.vue';
  import ScrollingTable from '@/components/Table/ScrollingTable.vue';
  import Help from '@/components/Help.vue';
  import VueSimpleAlert from 'vue3-simple-alert';
  import axios from 'axios'
  import DataTable from 'datatables.net-vue3'
  import DataTablesCore from 'datatables.net-bs5'
    
  // Register DataTables with Bootstrap 5 styling
  DataTable.use(DataTablesCore)

  export default {
    name: 'CustomersView',
    components: {Modal, PageContent, PageTitle, NotReady, PriceCodes, ItemListCodeArea, ColumnChooser, ScrollingTable, Help, DataTable},

    data(){
      return {
        _:_,
        allCustomers:[],
        rows:{},
        filter:{
            orderBy:'Name',
            order:'asc'
        },
        ready:false,
        searchText:'',
        search:{
            searchString:['true'],
            'No_':'',
            'City':'',
            'Name':'',
            'Phone No_':''
        },
        pagination:{
            search:'',
            pages:0,
            per_page:this.$store.state.localStorage.user['Customers_Per_Page'] ?? 25,
            page:0,
        },
      }
    },
    async mounted(){
      this.ready = true;
      await this.$nextTick();
      this.$refs.dataTable.dt.on('length.dt', (e, settings, len) => {
        this.$store.state.localStorage.user['Customers_Per_Page'] = len;
        localStorage.setItem('user', JSON.stringify(this.$store.state.localStorage.user));
      });
    },
    computed:{
      tableOptions() {
        return {
          // pageLength: localStorage.Customers_Per_Page ? !isNaN(+localStorage.Customers_Per_Page) ? (+localStorage.Customers_Per_Page): 25 : 25,
          pageLength: this.$store.state.localStorage.user['Customers_Per_Page'] ?? 25,
          lengthMenu: [[25, 50, 100, -1], [25, 50, 100, 'All']],
          scrollX: true,
          scrollY: '60vh',
          scrollCollapse: true,
          orderCellsTop: true,
          processing: true,
          serverSide: true,
          order: [[1, 'asc']],
          columnDefs: [{ targets: '_all', orderSequence: ['asc', 'desc'] }],
          ajax: {
            url: `${this.$store.state.api}/customers?token=${localStorage.token}`,
            type: 'GET',
            data: (data) => {
              // Map DataTables parameters to your API parameters
              return {
                draw: data.draw,
                start: data.start,
                length: data.length,
                search: data.search.value,
                orderBy: data.columns[data.order[0].column].data,
                orderDir: data.order[0].dir,
                'No_': data.columns[0].search.value,
                'Name': data.columns[1].search.value,
                'City': data.columns[2].search.value,
              };
            },
          }
        };
      },
      
    },
    methods:{
      searchColumn: _.debounce(function(colIndex, event){
        this.$refs.dataTable.dt.column(colIndex).search(event.target.value).draw();
      }, 300),
      async impersonate(customer){
        let req, res;
        sessionStorage.clear();
        localStorage.removeItem('shipTos');
        localStorage.removeItem('shipTo');
        localStorage.removeItem('openInvoices');
        localStorage.removeItem('account_status');
        
        localStorage.customer = JSON.stringify(customer);
        this.$store.state.localStorage.customer = customer;

        window.location = '/dashboard/';
      }
    },
    
  }
  </script>
  <style lang="scss">
  @import 'datatables.net-bs5';
  
  table.dataTable thead tr th,
  table.dataTable tbody tr td,
  table.dataTable tbody tr th {
    white-space: nowrap !important;
    font-size: 0.85rem;
  }

  table.dataTable thead tr th {
    position: sticky;
    top: 0;
    z-index: 1;
  }

  @media (max-width: 992px) {
    .dt-scroll-body{
      height: auto !important;
    }
  }
  </style>